import { App as MapCreateDrawer } from 'map-create-drawer'
import { useState } from 'react'
import { MapsTab as View } from 'ui-components'
import { MapList } from './MapList'
import { MapsTabTools } from './MapsTabTools'

const Maps = () => {
  const [open, setOpen] = useState(false)

  return (
    <View
      slots={{
        MapsTabTools,
        MapList,
        MapCreateDrawer
      }}
      slotProps={{
        MapCreateDrawer: {
          open: open,
          onClose: () => setOpen(false)
        },
        MapsTabTools: {
          onCreateMapClick: () => setOpen(true)
        },
        MapList: {
          onCreateMapClick: () => setOpen(true)
        }
      }}
    />
  )
}

export { Maps }
